import { englishLocaleKey, IntlMessages } from '@app/constants';

export const getIntlMessages = (
  locale: string
): Promise<Record<string, IntlMessages>> =>
  locale === englishLocaleKey
    ? Promise.resolve({ default: {} })
    : import(`../../lang/${locale}.json`);
